var parent = require('../../es/number/is-nan');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js-pure/stable/number/is-nan.js
// module id = 1411
// module chunks = 44